import React, { useEffect, useState } from 'react';
import '../css/global.css'
const UserProfile = () => {
  const [nickname, setNickname] = useState('');
  const [name, setName] = useState('');

  useEffect(() => {
    setNickname(localStorage.getItem('nickname'));
    setName(localStorage.getItem('name'));
  }, []);

  return (
    <div className='user-profile'>
      <p className='User-nickname'  style={{fontWeight:'bold'}}> {nickname}   </p>
      <p className='User-nickname' style={{color:'grey'}} >  {name}  </p>
      
    </div>
  );
};

export default UserProfile;

